<div class="row">
  <div class="col-12 mb-4">
    <app-chat-box (send)="sendMessage($event)"></app-chat-box>
  </div>
  <div class="col-12">
    <!-- chat box container start -->
    <app-chat-data
      [chatData]="chatData"
      [paging]="filter.page"
      [room]="userId"
      (loadMore)="loadMore($event)"
    ></app-chat-data>
    <!-- chat box container end -->
  </div>
</div>
